export const selectChatMessages = state => {
  return state.ChatReducer.messages;
};
export const isMessageArrived = state => {
  return state.ChatReducer.isMessageArrived;
};

export const showMessageToast = state => {
  return state.ChatReducer.showMessageToast;
};
